export default __webpack_public_path__ + "static/media/VIDEOSs.f95fad54.png";